<template>
  <div class="product-card" @click="gotoProductDetail(props.id)">
    <!-- <div v-if="discount" class="discount-badge">{{ discount }}% {{ t('products.off') || 'OFF' }}</div> -->
    <button class="btn-favorite" @click.stop="$emit('toggle-favorite', $props)">
          <span v-if="favoriteId != null && favoriteId != ''" class="favorite active"></span>
          <span v-else class="favorite"></span>
    </button>
    <div v-if="isNew" class="new-badge">{{ t('products.new') || 'NEW' }}</div>
    
    <div class="product-image" :style="productImageStyle">

    </div>
    
    <div class="product-details">
      <!-- 星级显示 -->
      <div class="ratings" v-if="rating" style="display: none;">
        <div class="stars" :style="{ '--rating': rating }"></div>
        <span v-if="reviewCount">({{ reviewCount }})</span>
      </div>

      <!-- 有货显示 -->
      <div class="product-availability" v-if="availability" style="display: none;">
        <span :class="['availability', availabilityClass]">{{ availability }}</span>
      </div>

      <div class="product_cnt">
        <div>
          <!-- 标题显示 -->
          <h3 class="product-title">{{ title }}<span class="product-brand cnt_brand">{{ brand }}</span></h3>
          
          <p class="product-brand" v-if="stock">{{ $t('purchase.stock') }}：{{ stock }}</p>
          <!-- 价格显示 -->
          <div class="product-price">
            <span class="current-price">${{ price.toFixed(2) }}</span>
            <span v-if="originalPrice && originalPrice > price" class="original-price">${{ originalPrice.toFixed(2) }}</span>
            <span v-if="unit" class="price-unit">/ {{ unit }}</span>
          </div>
        </div>

        <!-- 添加购物车 -->
         <div class="addcart-cnt">
          <div class="product-actions" @click="$emit('add-to-cart')"></div>
         </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const router = useRouter();

const { t } = useI18n();

interface Props {
  id?: string;
  imageUrl?: string;
  title: string;
  brand?: string;
  stock?: string;
  price: number;
  originalPrice?: number;
  unit?: string;
  discount?: number;
  rating?: number;
  reviewCount?: number;
  availability?: string;
  favoriteId?: string;
  isNew?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  id: '0',
  imageUrl: '',
  title: 'Product Title',
  brand: '',
  stock: '',
  price: 0,
  originalPrice: 0,
  unit: '',
  discount: 0,
  rating: 0,
  reviewCount: 0,
  availability: '',
  favoriteId: '',
  isNew: false
});

const productImageStyle = computed(() => {
  if (props.imageUrl) {
    // 先解码以避免双重编码，然后重新编码以生成有效的CSS URL
    const decodedUrl = decodeURI(props.imageUrl);
    const encodedUrl = encodeURI(decodedUrl.trim());
    console.log(encodedUrl);
    return { 
      // 在 url() 内部给地址加上单引号
      backgroundImage: `url('${encodedUrl}')`,
    };
  }
  return { backgroundColor: '#f0f0f0' };
});

const availabilityClass = computed(() => {
  if (!props.availability) return '';
  
  const avail = props.availability.toLowerCase();
  if (avail.includes(t('products.inStock').toLowerCase())) {
    return 'in-stock';
  } else if (avail.includes(t('products.outOfStock').toLowerCase())) {
    return 'out-of-stock';
  } else if (avail.includes(t('products.limitedStock').toLowerCase())) {
    return 'limited';
  }
  
  return '';
});

defineEmits(['add-to-cart', 'toggle-favorite']);
function gotoProductDetail(id: number) {
  router.push(`/purchase?categoryId=${id}`);
}
// 添加收藏状态管理函数

</script>

<style scoped lang="scss">
// Variables
$primary-color: #fb6e01; // Home Depot orange
$secondary-color: #fb6e01; // Home Depot blue
$light-gray: #f8f9fa;
$dark-gray: #333;
$white: #fff;
$border-color: #e0e0e0;
$star-color: #ffc107;

.btn-favorite {
  width: 40px;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}
.favorite{
  font-family: ico !important;
  font-size: 30px;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  margin: auto;
  line-height: 1;
  text-transform: none;
  display: inline-block;
  direction: ltr;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  color: #fb6e01;
}
.favorite:after {
    content: '\e917';
}
.favorite.active:after {
    content: '\e90b';
}
.product-card {
  position: relative;
  background-color: $white;
  border: 1px solid $border-color;
  padding: 0;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .discount-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: $primary-color;
    color: $white;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 4px;
    z-index: 1;
  }
  
  
  .new-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: $secondary-color;
    color: $white;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 4px;
    z-index: 1;
  }
}

.product-image {
  height: 300px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border-bottom: 1px solid $border-color;
  position: relative;
}

.product-details {
  padding: 15px;
  
  .ratings {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    
    .stars {
      position: relative;
      display: inline-block;
      font-family: Arial, sans-serif;
      color: #ddd;
      
      &:before {
        content: "★★★★★";
        font-size: 18px;
      }
      
      &:after {
        content: "★★★★★";
        font-size: 18px;
        position: absolute;
        left: 0;
        top: 0;
        color: $star-color;
        overflow: hidden;
        width: calc(var(--rating) * 20%);
      }
    }
    
    span {
      margin-left: 5px;
      color: #777;
      font-size: 14px;
    }
  }
  
  .product-title {
    font-size: 16px;
    margin: 0;
    font-weight: 500;
    line-height: 1.4;
    display: -webkit-box;
    word-break: break-word;
    padding-bottom: 6px;
  }
  
  .product-brand {
    font-size: 14px;
    color: #777;
    margin: 0;
    padding-bottom: 6px;
  }
  .cnt_brand{
    padding-left: 10px;
  }
  
  .product-price {
    word-break: break-word;
    
    .original-price {
      color: #999;
      text-decoration: line-through;
      font-size: 14px;
    }
    
    .current-price {
      color: $primary-color;
      font-size: 20px;
      font-weight: bold;
      margin-right: 5px;
    }
    
    .price-unit {
      font-size: 14px;
      color: #777;
    }
  }
  
  .product-availability {
    margin-bottom: 15px;
    
    .availability {
      display: inline-block;
      font-size: 14px;
      padding: 2px 8px;
      border-radius: 4px;
      
      &.in-stock {
        color: #2e7d32;
        background-color: #e8f5e9;
      }
      
      &.out-of-stock {
        color: #d32f2f;
        background-color: #ffebee;
      }
      
      &.limited {
        color: #ed6c02;
        background-color: #fff3e0;
      }
    }
  }
  .addcart-cnt{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .product-actions {
    color: #fb6e01;
    width: 50px;
    height: 50px;
    font-size: 30px;
    border: 2px #fb6e01 solid;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    transition-duration: .3s;
    cursor: pointer;
    
    &:hover {
      border-radius: 100%;
    }
    &::before {
      font-family: ico;
      content: "\eb84";
    }
  }
}
.product_cnt{
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .product-image {
    height: 180px;
  }
  
  .product-details {
    padding: 10px;
    
    .product-title {
      font-size: 14px;
    }
    
    .product-price {
      .current-price {
        font-size: 18px;
      }
    }
  }
  .product-actions{
    width: 30px!important;
    height: 30px!important;
    font-size: 20px!important;
  }
}
</style> 